import { UpdateUserDataRequestTypes } from '../_types/updateUserDataRequest.types';
import { apiUserAccount } from '../../../services/api/ApiService';
import { ApiEndpoints } from '../constantes/ApiEndpoints';
import { UserResponse } from '../_types/user.types';
import { ApiLocalStorage } from '../../../utils/ApiLocalStorage';
import { getSchemaIdFromStorage } from '../../../utils/getSchemaIdFromStorage';

export const useUserDataService = () => {
  const getUserData = async (): Promise<UserResponse> => {
    const schemaId = getSchemaIdFromStorage();
    const accessToken = ApiLocalStorage.get('@pwa:access-token');
    
    return await apiUserAccount.get<UserResponse>(
      `${ApiEndpoints.account.getUserMeData}?schemaId=${schemaId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
  };
  
  const updateUserData = async (data: UpdateUserDataRequestTypes): Promise<void> => {
    const schemaId = getSchemaIdFromStorage();
    const token = localStorage.getItem('@pwa:access-token');
    
    try {
      await apiUserAccount.put(
        `${ApiEndpoints.account.updateMe}?schemaId=${schemaId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
    } catch (error) {
      console.error('[updateUserData] Error occurred:', error);
      throw error;
    }
  };
  
  return {
    getUserData,
    updateUserData
  };
};
